import { makeAnimTrack, type Animation } from '@/core/animation';
import { CHARACTER_BONES as B } from './character';

const ROT_X = 0 as const;
const ROT_Y = 1 as const;
const ROT_Z = 2 as const;

export const IDLE_ANIM: Animation = {
  duration: 2.4,
  tracks: [
    makeAnimTrack(B.SPINE, ROT_Z, [
      [0, 0.035],
      [0.6, 0],
      [1.2, -0.035],
      [1.8, 0],
      [2.4, 0.035],
    ]),
    makeAnimTrack(B.HEAD, ROT_X, [
      [0, -0.02],
      [1.2, 0.03],
      [2.4, -0.02],
    ]),
  ],
};

export const WALK_ANIM: Animation = {
  duration: 0.7,
  tracks: [
    makeAnimTrack(B.LEG_L, ROT_X, [
      [0, 0.55],
      [0.35, -0.45],
      [0.7, 0.55],
    ]),
    makeAnimTrack(B.LEG_R, ROT_X, [
      [0, -0.45],
      [0.35, 0.55],
      [0.7, -0.45],
    ]),
    makeAnimTrack(B.ARM_L, ROT_X, [
      [0, -0.4],
      [0.35, 0.45],
      [0.7, -0.4],
    ]),
    makeAnimTrack(B.ARM_R, ROT_X, [
      [0, 0.45],
      [0.35, -0.4],
      [0.7, 0.45],
    ]),
    makeAnimTrack(B.SPINE, ROT_Y, [
      [0, 0.08],
      [0.35, -0.08],
      [0.7, 0.08],
    ]),
  ],
};
